/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreditCardHistoryGetResponseFromDiscriminatorValue, type CreditCardHistoryGetResponse } from '../../../models';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /creditcards/history/{currencyId}
 */
export interface WithCurrencyItemRequestBuilder extends BaseRequestBuilder<WithCurrencyItemRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreditCardHistoryGetResponse[]>}
     */
     get(requestConfiguration?: RequestConfiguration<WithCurrencyItemRequestBuilderGetQueryParameters> | undefined) : Promise<CreditCardHistoryGetResponse[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithCurrencyItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface WithCurrencyItemRequestBuilderGetQueryParameters {
    from?: Date;
}
/**
 * Uri template for the request builder.
 */
export const WithCurrencyItemRequestBuilderUriTemplate = "{+baseurl}/creditcards/history/{currencyId}{?from*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithCurrencyItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithCurrencyItemRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createCreditCardHistoryGetResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
